import { render } from "./CharteredBus.vue?vue&type=template&id=0b0b63a1"
import script from "./CharteredBus.vue?vue&type=script&lang=js"
export * from "./CharteredBus.vue?vue&type=script&lang=js"

import "./CharteredBus.vue?vue&type=style&index=0&id=0b0b63a1&lang=scss"

import exportComponent from "D:\\wwwroot\\yunchi\\yc-vue-source\\yunman\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__